import { withNamespaces } from "react-i18next";
import { RiErrorWarningLine } from "react-icons/ri";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const InvalidSelectionModal = ({ t, isOpen, toggle }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                <div className="d-flex justify-content-start align-items-center">
                    <RiErrorWarningLine className="me-2 text-warning" size={22} />
                    {t('Invalid Selection for Due Diligence Report')}
                </div>
            </ModalHeader>

            <ModalBody>
                <p className="mb-2">
                    {t('To generate a Due Diligence Report based on Geolocation, all selected products must share the same:')}
                </p>
                <ul className="mb-2">
                    <li><strong>{t('Country of Origin')}</strong></li>
                    <li><strong>{t('Date of Import')}</strong></li>
                </ul>
                <p className="mb-0">
                    {t('Please adjust your selection and try again.')}
                </p>
            </ModalBody>

            <ModalFooter>
                <Button color="primary" onClick={toggle}>
                    {t('OK, Got It')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    InvalidSelectionModal
);
